

export const parseIntoURLSearchParams = (
  toUpdate: {[key: string]: string | null | undefined | object},
) => {
  return Object.entries(toUpdate).reduce((acc, [key, value]) => {
    if (value === undefined || value === '' || value === null) {
      acc.delete(key);
    }
    else if (typeof value === 'object') {
      acc.set(key, JSON.stringify(value));
    } else {
      acc.set(key, value);
    }
    return acc;
  }, new URLSearchParams());
}